import { useEffect } from 'react';
import { useUnmount } from 'react-use';

import { useActions, useCollections, useProducts } from '@mssgme/hooks';

export const useProductsMain = (collectionPredicate) => {
    const collections = useCollections();
    const products = useProducts();
    const actions = useActions();
    const collection = collections.items.find(collectionPredicate);
    const collectionId = collection ? collection.id : null;
    const filter = JSON.stringify(products.filter);

    const loadMore = async () => {
        if (products.next && !products.isFetching) {
            await actions.api.products.list({
                guid: products.guid,
                query: {
                    collection: collectionId,
                    next: products.next,
                    filter: JSON.stringify(products.filter),
                },
            });
        }
    };

    const setFilter = ({ target: { name, value } }) => {
        actions.setProductsFilter({ [name]: value, collectionId });
    };

    useEffect(() => {
        if (collection || collections.items.length) {
            actions.api.products.list({
                guid: products.guid + 1,
                query: {
                    collection: collectionId,
                    filter,
                },
            });
        }
    }, [collections.items.length, products.guid, filter]);

    useUnmount(() => {
        actions.clearProductsStore();
    });

    return {
        collection,
        products,
        collections,
        setFilter,
        loadMore,
    };
};
